import { IncidentModel } from './incident.model';
export class OpsOfLawModel extends IncidentModel {
    public insuranceCompany: string;
    public insurancePolicy: string;
    public lienAgencyName: string;
    public lienAgencyPhoneNumber: string;
    public agencyTypeId: number;
}
